import gql from 'graphql-tag';

export const getReservationsByAdmin = gql`
  query getReservationsByAdmin($input: inputReservationsAdmin) {
    getReservationsByAdmin(input: $input) {
      count_rows
      current_page
      can_back
      can_next
      total_page
      deals {
        id
        state
        reserveCoin
        createdAt
        closedAt
        expiredAt
        offer {
          title
        }
        consumer {
          username
        }
        merchant {
          username
        }
      }
    }
  }
`;
